import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-white/10 backdrop-blur-sm'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://static.readdy.ai/image/44d896a69a1929a78f12b3528cb3985b/baaebd26657538e4da185299f5ed494d.png" 
              alt="Legacy Digitization Experts Logo" 
              className="h-12 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('services')} className={`text-sm font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#D97706]' : 'text-white hover:text-[#D97706]'}`}>
              Services
            </button>
            <button onClick={() => scrollToSection('programs')} className={`text-sm font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#D97706]' : 'text-white hover:text-[#D97706]'}`}>
              Programs
            </button>
            <button onClick={() => scrollToSection('testimonials')} className={`text-sm font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#D97706]' : 'text-white hover:text-[#D97706]'}`}>
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className={`text-sm font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#D97706]' : 'text-white hover:text-[#D97706]'}`}>
              Contact
            </button>
          </div>

          <button onClick={() => scrollToSection('booking')} className="hidden md:block bg-[#D97706] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#B45309] transition-colors whitespace-nowrap">
            Book Consultation <i className="ri-arrow-right-line ml-1"></i>
          </button>

          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden text-2xl">
            <i className={scrolled ? 'ri-menu-3-line text-gray-700' : 'ri-menu-3-line text-white'}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3">
            <button onClick={() => scrollToSection('services')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#D97706] transition-colors whitespace-nowrap">
              Services
            </button>
            <button onClick={() => scrollToSection('programs')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#D97706] transition-colors whitespace-nowrap">
              Programs
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#D97706] transition-colors whitespace-nowrap">
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#D97706] transition-colors whitespace-nowrap">
              Contact
            </button>
            <button onClick={() => scrollToSection('booking')} className="w-full bg-[#D97706] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#B45309] transition-colors whitespace-nowrap">
              Book Consultation <i className="ri-arrow-right-line ml-1"></i>
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
